// extracted by mini-css-extract-plugin
export default {"container":"LiveTableLayer_container__wKiER"};